import VNotificationList from './VNotificationList'

export default VNotificationList
